<template>
    <div class="animated fadeIn">
        <loading :active.sync="isLoading"></loading>
        <h2>{{ $t('menu.update_menu') }}</h2>
        <b-row>
            <b-col lg="6" md="6" sm="6" style="align-items: flex-end;display: flex;">
                <!-- <label for="clients">Select Meal</label> -->
                <b-row style="width:100%;">
                    <b-col class="highlighted" lg="8" md="7" sm="7">
                        <label for="clients">{{ $t('menu.select_client') }}
                        <i class="fa fa-info-circle" data-toggle="tooltip" :title="$t('menu.select_client_to_create_menu')" data-original-title=""></i>
                        </label>
                        <b-form-select id="clients" v-model="selectedClient" @onSelect="selectChanged()"
                            :plain="true"
                            :options="clients">
                        </b-form-select>
                    </b-col>
                    <b-col class="highlighted" lg="4" md="5" sm="5" style="align-items: flex-end;display: flex;">
                        <b-form-select id="clients" v-model="selectedDiet" @onSelect="selectChangedDiets()"
                            :plain="true"
                            :options="diets[language]">
                        </b-form-select>
                        <i class="fa fa-info-circle" data-toggle="tooltip" :title="$t('menu.select_menu_diet')" data-original-title="" style="line-height:34px;margin-left: 3px;"></i>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="6" md="6" sm="6" style="align-items: flex-end;display: flex;">
                <!-- <label for="clients">Select Meal</label> -->
                <b-row style="width:100%;">
                    <b-col class="highlighted" lg="8" md="7" sm="7" style="align-items: flex-end;display: flex;">
                        <!-- <label for="clients">Select Meal</label> -->
                        <b-form-select id="clients" v-model="selectedType" 
                            :plain="true"
                            :options="mealTypes">
                        </b-form-select>
                        <i class="fa fa-info-circle" data-toggle="tooltip" :title="$t('menu.select_daily_meal')" data-original-title="" style="line-height:34px;margin-left: 3px;"></i>
                    </b-col>
                    <b-col class="highlighted" lg="4" md="5" sm="5" style="align-items: flex-end;display: flex;">
                        <b-button type="button" size="md" variant="primary">{{ $t('menu.choose_meal') }}</b-button>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row style="justify-content: space-between;">
            <b-col lg="6" md="6" sm="6" style="align-items: flex-end;display: flex;">
                <b-row style="width:100%;">
                    <b-col class="highlighted" lg="8" md="7" sm="7" style="align-items: flex-end;display: flex;">
                        <!-- <label for="clients">Select Meal</label> -->
                        <b-form-select style="width:100%;" v-model="selectedFoodType"
                            :plain="true"
                            :options="foodTypes[language] | dietFilter(selectedDiet,foodTypesData,language,$i18n.t('menu.select_diet'))">
                        </b-form-select>
                        <i class="fa fa-info-circle" data-toggle="tooltip" :title="$t('menu.select_food_type_menu')" data-original-title="" style="line-height:34px;margin-left: 3px;"></i>
                    </b-col>
                    <b-col class="highlighted" lg="4" md="5" sm="5" style="align-items: flex-end;display: flex;">
                        <b-button type="button" size="md" variant="primary" @click="selectFoodType()">{{ $t('menu.select_food_type') }}</b-button>
                    </b-col>
                </b-row>
            </b-col>
            <b-col class="highlighted" lg="5" md="5" sm="5" style="align-items: flex-end;display: flex;">
                <!-- <label for="clients">Select Meal</label> -->
                <div class="input-group">
                    <input type="text" v-model="searchText" class="form-control" placeholder="Search Food">
                    <div class="input-group-append">
                        <button class="btn btn-secondary" @click="selectFoodType()" type="button">
                        <i class="fa fa-search"></i>
                        </button>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row style="margin-top:10px;" class="align-end">
            <b-col lg="4" md="6" sm="8" class="align-end">
                <b-row class="align-end" style="width:100%;">
                    <b-col lg="12" md="12" sm="12" class="align-end">
                        <b-button style="width:100%;" type="button" size="md" variant="primary" @click="addFoodModal=true;">{{ $t('menu.create_custom_food') }}</b-button>
                        <i class="fa fa-info-circle" data-toggle="tooltip" :title="$t('menu.create_custom_food_for_menu')" data-original-title="" style="line-height:34px;margin-left: 3px;"></i>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row style="margin-top:10px;" class="align-end">
            <b-col lg="4" md="6" sm="8" class="align-end">
                <b-row class="align-end" style="width:100%;">
                    <b-col lg="12" md="12" sm="12" class="align-end">
                        <b-button style="width:100%;" type="button" size="md" variant="primary" @click="addFoodTypeModal=true;">{{ $t('menu.create_food_category') }}</b-button>
                        <i class="fa fa-info-circle" data-toggle="tooltip" :title="$t('menu.create_menu_food_type')" data-original-title="" style="line-height:34px;margin-left: 3px;"></i>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <h4 class="header">{{ $t('menu.meals_created') }}</h4>
        </b-row >
        <b-row v-for="(meal,index) in createdMeals" class="food-item bordered">
            <b-col lg="3" md="4" sm="5">
                <b>{{ $t('menu.meal') }} {{(meal.type)}}  ||  </b>  <b>{{ $t('menu.energy') }} : </b> <span> {{ meal.foods | totalCal }}</span>
            </b-col>
            <b-col lg="8" md="7" sm="6">
                <span v-for="foodMeal in meal.foods">
                    <span v-if="language == 'en'">{{foodMeal.english_title}}</span><span v-if="language == 'iw'">{{foodMeal.hebrew_title}}</span>, <!-- <b>{{ $t('menu.qty') }} : </b> {{foodMeal.qty}} , -->  <b>{{ $t('menu.energy') }} : </b> {{foodMeal.energy_kc}} , <b>{{ $t('menu.serving') }} : </b>{{foodMeal.servingVal}} {{foodMeal.serving}} <b> ||  </b>
                </span>
            </b-col>
            <b-col lg="1" md="1" sm="1">
                <b-button aria-label="Close" class="close remove-button" @click="removeMeal(index)">x</b-button>
            </b-col>
        </b-row>
        <b-row>
            <h4 class="header">{{ $t('menu.select_meal') }}</h4>
        </b-row>
        <b-row class="food-row highlighted">
            <b-col lg="12">
                <b-row v-for="(food,index) in foodDataShow" class="food-item">
                    <b-col v-if="language == 'en'" class="not-highlighted" lg="5" md="5" sm="5">
                        {{food.english_title}}
                    </b-col>
                    <b-col v-if="language == 'iw'" class="not-highlighted" lg="5" md="5" sm="5">
                        {{food.hebrew_title}}
                    </b-col>
                    <!-- <b-col lg="2" md="2" sm="2">
                        {{food.supplier.shop_name}}
                        </b-col> -->
                    <b-col lg="1" md="1" sm="1">
                        <b-button @click="add(food)">+</b-button>
                    </b-col>
                    <b-col lg="1" md="1" sm="1">
                        <b-button @click="show(food.id)">{{ $t('menu.details') }}</b-button>
                    </b-col>
                    <b-col lg="5" md="5" sm="5">
                        <!-- v-if="!!showDetails" -->
                        <b-row v-if="food.id == descriptionToShow">
                            <b-col lg="6" md="6" sm="6">
                                <p class="data-info" v-if="!!showData"> {{ $t('menu.energy') }}  </p>
                                <p class="data-value" v-if="!!showData"> {{showData.energy_kc}}</p>
                            </b-col>
                            <b-col lg="6" md="6" sm="6">
                                <p class="data-info" v-if="!!showData"> {{ $t('menu.size') }}  </p>
                                <p class="data-value" v-if="!!showData"> {{showData.weightgram}}</p>
                            </b-col>
                        </b-row>
                        <b-row v-if="food.id == descriptionToShow">
                            <b-col lg="12" md="12" sm="12" style="text-align:center;">
                                <b-button @click="showMoreDetails(food,showData)">{{ $t('menu.more_details') }}</b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row class="title-meals highlighted">
            <b-col lg="12" md="12" sm="12" style="align-items: flex-end;display: flex;">
                <h4>{{ $t('menu.meal_foods_selected') }} {{selectedType}}</h4>
            </b-col>
        </b-row>
        <b-row class="food-row highlighted">
            <b-col lg="12">
                <b-row v-for="(food,i) in selectedFoods" class="food-item">
                    <b-col v-if="language == 'en'" lg="4" md="4" sm="4" class="not-highlighted">
                        {{food.english_title}}
                    </b-col>
                    <b-col v-if="language == 'iw'" lg="4" md="4" sm="4" class="not-highlighted">
                        {{food.hebrew_title}}
                    </b-col>
                    <b-col lg="2" md="2" sm="2">
                        <b-form-select id="clients" v-model="food.serving" 
                            :plain="true"
                            :options="servingSizes[language]" @change="selectServingSize($event,food,i)">
                        </b-form-select>
                    </b-col>
                    <b-col lg="1" md="1" sm="1">
                        <b-button @click="remove(food,i)">-</b-button>
                    </b-col>
                    <!-- <b-col lg="1" md="1" sm="1">
                        {{food.qty}}
                        </b-col> -->
                    <b-col lg="1" md="1" sm="1">
                        <b-button @click="addQty(food,i)">+</b-button>
                    </b-col>
                    <b-col lg="1" md="1" sm="1">
                        <b>Energy : </b>{{food.energy_kc}}
                    </b-col>
                    <b-col lg="2" md="2" sm="2">
                        <b>Serving : </b> {{food.servingVal}} {{food.serving}}
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row class="title-meals highlighted">
            <b-col lg="4" md="4" sm="4" style="align-items: flex-end;display: flex;">
                <h4>{{ $t('menu.meal') }} : {{selectedType}} , <b>{{ $t('menu.energy') }} : </b> {{ selectedFoods | totalCal}}</h4>
            </b-col>
            <b-col lg="6" md="6" sm="6" style="align-items: flex-end;display: flex;">
                <b-button type="button" :disabled="selectedFoods.length == 0" size="md" variant="primary" @click="addMeal()">{{ $t('menu.add_another_meal') }}</b-button>
            </b-col>
        </b-row>
        <b-row class="highlighted">
            <b-col lg="12" md="12" sm="12">
                <b-row style="justify-content:space-around">
                    <b-col lg="2" md="2" sm="2" class="meals">
                        <div class="type not-highlighted">{{ $t('menu.breakfast') }} <i v-if="createdMealTypes.indexOf($t('menu.breakfast','en')) !== -1 || createdMealTypes.indexOf($t('menu.breakfast','iw')) !== -1" class="fa fa-check fa-lg"></i>
                            <span v-if="breakfast_calories != 0" class="calc-calories">&nbsp;&nbsp;{{ breakfast_calories }}</span>
                        </div>
                    </b-col>
                    <b-col lg="2" md="2" sm="2" class="meals">
                        <div class="type not-highlighted">{{ $t('menu.brunch') }}  <i v-if="createdMealTypes.indexOf($t('menu.brunch','en')) !== -1 || createdMealTypes.indexOf($t('menu.brunch','iw')) !== -1" class="fa fa-check fa-lg"></i>
                            <span v-if="brunch_calories != 0" class="calc-calories">&nbsp;&nbsp;{{ brunch_calories }}</span>
                        </div>
                    </b-col>
                    <b-col lg="2" md="2" sm="2" class="meals">
                        <div class="type not-highlighted">{{ $t('menu.lunch') }}  <i v-if="createdMealTypes.indexOf($t('menu.lunch','en')) !== -1 || createdMealTypes.indexOf($t('menu.lunch','iw')) !== -1" class="fa fa-check fa-lg"></i>
                            <span v-if="lunch_calories != 0" class="calc-calories">&nbsp;&nbsp;{{ lunch_calories }}</span>
                        </div>
                    </b-col>
                    <b-col lg="2" md="2" sm="2" class="meals">
                        <div class="type not-highlighted">{{ $t('menu.afternoon') }}  <i v-if="createdMealTypes.indexOf($t('menu.afternoon','en')) !== -1 || createdMealTypes.indexOf($t('menu.afternoon','iw')) !== -1" class="fa fa-check fa-lg"></i>
                            <span v-if="afternoon_calories != 0" class="calc-calories">&nbsp;&nbsp;{{ afternoon_calories }}</span>
                        </div>
                    </b-col>
                    <b-col lg="2" md="2" sm="2" class="meals">
                        <div class="type not-highlighted">{{ $t('menu.dinner') }}  <i v-if="createdMealTypes.indexOf($t('menu.dinner','en')) !== -1 || createdMealTypes.indexOf($t('menu.dinner','iw')) !== -1" class="fa fa-check fa-lg"></i>
                            <span v-if="dinner_calories != 0" class="calc-calories">&nbsp;&nbsp;{{ dinner_calories }}</span>
                        </div>
                    </b-col>
                    <b-col lg="2" md="2" sm="2" class="meals">
                        <div class="type not-highlighted">{{ $t('menu.goodnight') }}  <i v-if="createdMealTypes.indexOf($t('menu.goodnight','en')) !== -1 || createdMealTypes.indexOf($t('menu.goodnight','iw')) !== -1" class="fa fa-check fa-lg"></i>
                            <span v-if="goodnight_calories != 0" class="calc-calories">&nbsp;&nbsp;{{ goodnight_calories }}</span>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <p class="pull-right calc-calories">
                            {{ $t('menu.total_calories_for')+' '+$t('menu.day')+' '+day+' '+'='+' '+calcTotalCalForDay(day) }}
                        </p>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row class="highlighted">
            <b-col lg="12" md="12" sm="12">
                <b-row style="justify-content:space-between">
                    <b-col lg="6" md="6" sm="6" class="align-middle">
                        <label style="margin-top: 22px; margin-right: 20px;white-space: nowrap;">{{ $t('weeks.select_week') }}</label>

                        <b-form-select v-model="week" :options="weeks"  class="align-middle mt-3" required>
                        </b-form-select>
                    </b-col>

                    <b-col v-show="selected_date !== null" lg="6" md="6" sm="6" class="align-middle">
                        <label style="margin-top: 22px; font-weight: bold;">{{ $t('weeks.date_selected') }}:  {{ selected_date }}</label>
                    </b-col>
                </b-row>
                <br>
                <b-row style="justify-content:space-between">
                    <b-col lg="6" md="6" sm="6"  class="align-middle">
                        <b-form-group  class="align-middle"
                            label="Select the day of the menu"
                            label-for="basicRadios"
                            :label-cols="3"
                            :horizontal="false">
                            <b-form-radio-group class="align-middle" id="basicRadios" v-model="day"
                                :plain="true"
                                :options="[
                                    {text: $t('menu.day')+' 1 ',value: '1'},
                                    {text: $t('menu.day')+' 2 ',value: '2'},
                                    {text: $t('menu.day')+' 3 ',value: '3'},
                                    {text: $t('menu.day')+' 4 ',value: '4'},
                                    {text: $t('menu.day')+' 5 ',value: '5'},
                                    {text: $t('menu.day')+' 6 ',value: '6'},
                                    {text: $t('menu.day')+' 7 ',value: '7'}
                                ]"
                                checked="1" @change="changeDayCalories()">
                            </b-form-radio-group>
                        </b-form-group>
                    </b-col>
                    <b-col lg="6" md="6" sm="6" class="align-end">
                        <b-row class="align-end">
                            <b-col lg="12" md="12" sm="12" class="align-end">
                                <b-button type="button" :disabled="!!disableCreateMenu" size="md" variant="primary" @click="createMenu()">{{ $t('menu.save_menu_button') }}</b-button>
                            </b-col>
                            <b-col lg="12" md="12" sm="12" class="align-end" style="margin-top:5px;">
                                <b-button type="button" :disabled="!!disableCreateMenu" size="md" variant="success" @click="createMenu(true)">{{ $t('menu.save_and_share') }}</b-button>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-modal title="Payment Needed" size="md" v-model="modal">
            <h4> {{$t('menu.payment_needed')}} </h4>
            <PayPal :amount="amount" @payment-authorized="authorized($event)" @payment-cancelled="cancelled($event)" @payment-completed="completed($event)" currency="ILS" :client="paypal" env="sandbox"></PayPal>
        </b-modal>
        <b-modal title="Food" size="xl" v-model="foodModal">
            <FoodsModal class="food-modal" :food="usedFood" :showData="showData"></FoodsModal>
        </b-modal>
        <b-modal title="Create Food" size="xl" v-model="addFoodModal" @ok="addFood()">
            <AddFoodModal ref="addFoodsModal" class="food-modal" :nutritionist="getUser.nutritionist" :language = "language" :food_types="foodTypes" :food="foods[0]" :showData="foodData[0]"></AddFoodModal>
        </b-modal>
        <b-modal title="Create Food Type" size="xl" v-model="addFoodTypeModal" @ok="addFoodType()">
            <AddFoodTypeModal ref="addFoodsTypeModal" class="food-modal" :nutritionist="getUser.nutritionist" :diets="diets" :language = "language"></AddFoodTypeModal>
        </b-modal>
    </div>
</template>

<script>
    import moment from 'moment';
    import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
    import Models from '@/store/ORM/models.js';
    import DataMenuService from '@/services/datamenu.service.js';
    import _ from 'lodash';
    import PayPal from 'vue-paypal-checkout';
    import CreatedMenu from '@/store/ORM/created-menu.js';
    import FoodsModal from '@/components/FoodsModal';
    import AddFoodModal from '@/components/AddFoodModal';
    import AddFoodTypeModal from '@/components/AddFoodTypeModal';
    import InfoService from '@/services/info.service.js';
    import WeekService from '@/services/week.service.js';
    //Sandbox Email PSW
    //sb-f43pdm723645@personal.example.com
    //Te1f*Hd1

    export default {
        name: 'create-menu',
        components: {
            PayPal,
            FoodsModal,
            AddFoodModal,
            AddFoodTypeModal,
        },
        data: function () {
            return {
                selectedClient: null,
                selectedType: 'Breakfast',
                foods : [],
                selectedFoods : [],
                isLoading: false,
                descriptionToShow : -1,
                modal : false,
                amount : 5,
                createdMeals : [],
                foodData:[],
                foodTypes : {en:[],iw:[]},
                foodDataShow : [],
                foodTypesData : [],
                usedFood : {},
                selectedFoodType:null,
                searchText: '',
                showDetails: false,
                showData: null,
                createdMealTypes : [],
                foodModal:false,
                addFoodTypeModal:false,
                addFoodModal:false,
                // food: null,
                share:false,
                selectedDiet:this.$i18n.t('menu.select_diet'),
                diets: { en: [this.$i18n.t('menu.select_diet')], iw: [this.$i18n.t('menu.select_diet')] },
                servingSizes: { en: [], iw: [] },
                servingSizesData: [],
                day:1,
                paypal: {
                    sandbox: 'ARLHjspwH3GQ8oJpd0qO1WKmX6pgVUDa3YEmu5lXMu45utzCYVBSCiQ3A1dcXCjKRTw8Gx-6hBisaxkI',
                    production: '<production client id>'
                },
                menu:null,
                clientInfos : Models.Client.query().with("createdmenus").get(),
                meal_calories: 0,
                breakfast_calories : 0,
                brunch_calories : 0,
                lunch_calories : 0,
                afternoon_calories : 0,
                dinner_calories : 0,
                goodnight_calories : 0,
                week: null,
                weeks: [],
                selected_date: null
            }
        },

        created() {

            this.isLoading = true;

            this.fetchWeeks();

            //set menu
            this.menu = Models.CreatedMenu.query().where('id',parseInt(this.$route.params.id)).with('client').with('nutritionist').with('week').first();
            console.log(this.menu);

            //set created meals
            this.createdMeals = this.menu.meals;

            //set client
            let client = Models.Client.query().where('id', this.menu.client_id).first();

            if(this.menu.week_id) {
                this.week = this.menu.week_id;
            }

            this.selectedClient = this.menu.client_id+' '+client.first_name+ ' ' +client.last_name;

            this.day = this.menu.day;

            //set selecte date of week
            this.selected_date = this.formatDayOfWeek;

            this.createdMeals.forEach((meal)=>{
                this.calculateCalories(meal.type);
                this.createdMealTypes.push(meal.type)
            });

            setTimeout(()=>{
                this.isLoading = false;
            },2000);

            InfoService.getDietTypes().then((res)=>{
                if(res.data.success){
                    res.data.dietTypes.forEach((diet)=>{
                        this.diets.en.push(diet.name_en);
                        this.diets.iw.push(diet.name_iw);
                    });
                }else{
                    alert("ERROR");
                }
            },err => {
                alert("ERROR");
            });

            DataMenuService.getFoods(this.getUser.nutritionist.id)
            .then((res)=>{
                this.foods = res.data;
                // this.foodDataShow = res.data;
            })
            .catch((error)=>{
                alert(error);
                this.isLoading = false;
            });

            DataMenuService.getFoodsData(this.getUser.nutritionist.id)
            .then((res)=>{
                this.foodData = res.data;
                this.foodData.map(el=>{
                    let data = [];
                    el.data.map( (elm,index) => {
                        data[elm.name] = elm.value;
                    })
                    el.data = Object.assign({}, data);
                });
            })
            .catch((error)=>{
                alert(error);
            });

            DataMenuService.getFoodsTypes()
            .then((res)=>{
                this.foodTypesData = res.data;
                res.data.forEach((el)=>{
                    this.foodTypes.en.push(el.info[0].name);
                    this.foodTypes.iw.push(el.info[1].name);
                });
            })
            .catch((error)=>{
                alert(error);
            });

            InfoService.getServingSizes().then((res)=>{
                if(res.data.success){
                    res.data.servingSize.forEach((servingSize)=>{
                        this.servingSizes.en.push(servingSize.serving_en);
                        this.servingSizes.iw.push(servingSize.serving_iw);
                        this.servingSizesData.push(servingSize);
                    });
                    }else{
                        alert("ERROR");
                    }
                },err => {
                alert("ERROR");
            });

            DataMenuService.getMenusPrice()
            .then((res)=>{
                this.amount = res.data.value;
            })
            .catch((error)=>{
                alert(error);
            });

            if(!!this.$route.params.id ||  parseInt(this.$route.params.id) == 0){
                let selectedClient = this.clients.find((el) => {
                    return el.split(' ')[0] == parseInt(this.$route.params.id);
                })
                if(selectedClient){
                    this.selectedClient = selectedClient;
                }
            }
        },

        computed: {

            disableCreateMenu: function() {
                if(this.createdMeals.length == 0 || this.week == null) {
                    return true;
                }
                return false;
            },

            clients() {
                let cli = Models.Client.all();
                let options = []
                for (let i in cli) {
                    let repr = cli[i].id + ' ' + cli[i].first_name + ' ' + cli[i].last_name
                    var d = new Object()
                    d.text = repr
                    d.value = cli[i].id
                    options.push(repr)
                }
                return options
            },

            getUser : function() {
                return this.$store.state['UserModules'].user;
            },

            language() {
                this.selectedFoodType = null;
                return this.$store.getters['UserModules/getLanguage']
            },

            mealTypes(){
                return [ this.$i18n.t('menu.breakfast'),this.$i18n.t('menu.brunch'),this.$i18n.t('menu.lunch'),this.$i18n.t('menu.afternoon'),this.$i18n.t('menu.dinner'),this.$i18n.t('menu.goodnight')];
            },

            client(){
                return this.clientInfos.find((elm)=> {return elm.id == this.selectedClient.split(' ')[0]})
            },

            dailMax(){
                if(!this.client){
                    return 0;
                }

                let menus = this.client.createdmenus.filter((menu) => {return menu.day == this.day});

                let energy = 0;

                menus.forEach((menu)=>{
                    if(this.menu.id != menu.id){
                        menu.meals.forEach((meal)=>{
                            meal.foods.forEach((food)=>{
                                energy += food.energy_kc;
                            });
                        });
                    }
                });
                return energy;
            },

            maxCalories(){
              let energy = 0;
                this.createdMeals.forEach((meal)=>{
                  meal.foods.forEach((food)=>{
                    energy += food.energy_kc;
                  });
                });
              return energy;
            },

            selectedFoodsMaxCal(){
                let energy = 0;
                this.selectedFoods.forEach((food)=>{
                    energy += food.energy_kc;
                });
                return energy;
            },

            formatDayOfWeek: function() {
                if(this.menu.week){

                    var dates = [];
                    var start_date = new Date(this.menu.week.start);

                    dates.push(this.menu.week.start);

                    for (var i = 0; i < 6; i++) {
                        var newDate = start_date.setDate(new Date(start_date).getDate() + 1);
                        newDate = moment(newDate).format("YYYY-MM-DD");
                        dates.push(newDate);
                    }

                    dates.push(this.menu.week.end);

                    var day = parseInt(this.menu.day)-1;
                    var date = dates[day];

                    return this.formatLocaleDate(date);
                }
                return "";
            },
        },

        filters:{

            dietFilter(options,selectedDiet,foodTypesData,language,dietDefault){
                if(!selectedDiet || selectedDiet == dietDefault){
                    return options;
                }else{
                    let opts = [];
                    foodTypesData.forEach((foodType)=>{
                        if(language == 'en'){
                            if(foodType['dietEn'].indexOf(selectedDiet) !== -1 ){
                                opts.push(foodType.info[0].name);
                            }
                        }else{
                            if(foodType['dietIw'].indexOf(selectedDiet) !== -1 ){
                                opts.push(foodType.info[1].name);
                            }
                        }
                    });
                    return opts;
                }
            },

            totalCal : function(foods){
                let total = 0;

                foods.forEach((food)=>{
                    if(food.energy_kc){
                        total += food.energy_kc;
                    }
                });

                return total;
            }
        },

        methods: {
            /**
             *
            */
            formatLocaleDate: function(date) {

                const options = { weekday: 'long', year: "numeric", month: "long", day: "numeric" };

                return (this.language == 'en') ? new Date(date).toLocaleDateString("en-US", options) : new Date(date).toLocaleDateString("he-IL", options);
            },

            /**
             *
            */
            getDateOfWeek: function() {

                var vm = this;

                if(this.week != null) {
                    var vm = this;

                    var index = this.weeks.findIndex(w => w.value == this.week);

                    if(index != -1) {
                        this.selected_date = this.getDatesBetweenDates(this.weeks[index].start, this.weeks[index].end, this.day);
                    }
                }
            },

            getDatesBetweenDates(startDate, endDate, day) {

                var days = parseInt(day);
                var date = new Date(startDate);

                date = date.setDate(date.getDate() + (days -1));
                const options = { weekday: 'long', year: "numeric", month: "long", day: "numeric" };

                this.selected_date = (this.language == "en") ? new Date(date).toLocaleDateString("en-Us", options) : new Date(date).toLocaleDateString("he-IL", options);

                return this.selected_date;
            },

            add(food,foodInfo){
                // this.isLoading = true;
                let info = this.foodData.find((el)=> {return el.food_id == food.id});

                food.qty = 1;
                food.energy_kc = info.data.energy_kc;

                if( !!this.client && this.client.max_cals && (parseFloat(this.client.max_cals) - (this.dailMax+this.maxCalories+this.selectedFoodsMaxCal+food.energy_kc) < 0 )){
                    this.showCaloriesMaxAlert().then((res)=>{

                        let info = this.foodData.find((el)=> {return el.food_id == food.id});

                        food.qty = 1;
                        food.energy_kc = info.data.energy_kc;
                        this.selectedFoods.push(food);
                    }).catch((err)=>{
                        return;
                    })
                }else{
                    this.selectedFoods.push(food);
                }

                // this.isLoading = false;
            },

            addQty(food,i){

                food.qty++;
                food.energy_kc += food.energy_kc;
                if(food.servingVal){
                    food.servingVal += parseFloat(food.servingObj.basic_size);
                }

                if( !!this.client && this.client.max_cals && (parseFloat(this.client.max_cals) - (this.dailMax+this.maxCalories+this.selectedFoodsMaxCal+food.energy_kc) < 0 )){
                    this.showCaloriesMaxAlert().then((res)=>{
                    this.$set(this.selectedFoods,i,food);
                        }).catch((err)=>{
                        return;
                    })
                }else{
                    this.$set(this.selectedFoods,i,food);
                }

                // this.selectedFoods[i].qty++;
                // this.selectedFoods[i].energy_kc += this.selectedFoods[i].energy_kc;
            },

            show(id){
                console.log(id);
                if(this.descriptionToShow == id){
                    this.descriptionToShow = -1;
                    this.showDetails = false;
                }else{
                this.showData = this.foodData.find(el=> {return el.food_id == id}).data;
                    this.descriptionToShow = id;
                    this.showDetails = true;
                }
            },

            remove(food,i){
                if(food.qty == 1){
                    this.selectedFoods.splice(i, 1);
                }else{
                    food.qty--;
                    food.energy_kc -= food.energy_kc;

                    if(food.servingVal){
                        food.servingVal -= parseFloat(food.servingObj.basic_size);
                    }

                    this.$set(this.selectedFoods,i,food);
                    //   this.selectedFoods[index].qty--;
                    // this.selectedFoods[index].energy_kc -= this.selectedFoods[index].energy_kc;
                }
            },

            showCaloriesMaxAlert(){
                return new Promise((resolve,reject)=>{

                    var i18n = this.$i18n;
                    this.$swal({
                        title: this.$i18n.t('menu.limit_reached'),
                        icon: "warning",
                        buttons: {
                            cancel: this.$i18n.t('menu.no'),
                            ok: {
                                text: this.$i18n.t('menu.yes'),
                                value: "yes",
                            }
                        },
                        dangerMode: true,
                    })
                    .then((willDelete) => {
                        if (willDelete) {
                            resolve(true);
                        }else{
                            reject(true);
                        }
                    });
                });
            },

            selectServingSize(event,food,i){

                let serving = this.servingSizesData.find((el) => {
                    return el["serving_"+this.language] == food.serving;
                });

                food.servingVal = parseFloat(serving.basic_size) * food.qty;
                food.servingObj = serving;
                this.$set(this.selectedFoods,i,food);
            },

            createMenu(share = false){
                // let createdMenus = CreatedMenu.query().where('client_id',this.selectedClient).get();
                this.share = share;
                // if(createdMenus.length == 0){
                this.pay();
                // }else{
                //   this.modal = true;
                // }
            },

            removeMeal(index){
                this.createdMeals.splice(index, 1);
            },

            showMoreDetails(food,showData){
                // this.food= food;
                this.usedFood = Object.assign( {} , food);
                this.foodModal = true;
            },

            addFood(){
                // this.$refs['addEvent'].form.submit();
                this.$refs['addFoodsModal'].add().then((res)=>{
                    if(res.success){
                        this.foods.push(res.food);

                        let data = [];

                        res.food.data.map( (elm,index) => {
                            data[elm.name] = elm.value;
                        })

                        this.foodData.push({food_id : res.food.id, data: data});

                        if(!!this.searchText || !!this.selectedFoodType){
                            this.selectFoodType();
                        }
                    }
                });
            },

            addFoodType(){
                // this.$refs['addEvent'].form.submit();
                this.$refs['addFoodsTypeModal'].add().then((res)=>{
                    if(res.success){
                        this.foodTypes.en.push(res.foodType.info[0].name);
                        this.foodTypes.iw.push(res.foodType.info[1].name);
                        this.foodTypesData.push(res.foodType);
                    }
                });
            },

            authorized(event){
                // console.log(event)
            },

            cancelled(event){
                // console.log(event)
            },

            completed(event){
                this.modal = false;
                this.isLoading = true;
                this.pay();
            },

            pay(share){
                if(!this.selectedClient || !this.day || !this.week){
                    this.$toastr.error(this.$t('weeks.required_fields_error'), 'Error!');
                    return;
                }
                console.log(this.week);
                var body = {
                    nutricionist_id : this.getUser.nutritionist.id,
                    client_id : this.selectedClient.split(' ')[0],
                    meals : this.createdMeals,
                    day : this.day,
                    share:this.share,
                    week: this.week
                };

                var vm = this;

                DataMenuService.updateMenu(this.menu.id,body).then((res)=>{
                    vm.selectedClient = null;
                    vm.selectedType = 'Breakfast';
                    vm.selectedFoods = [];
                    vm.createdMeals = [];
                    vm.createdMealTypes = [];
                    vm.updateMenus();
                    vm.mealTypes = [ vm.$i18n.t('menu.breakfast'),vm.$i18n.t('menu.brunch'),vm.$i18n.t('menu.lunch'),vm.$i18n.t('menu.afternoon'),vm.$i18n.t('menu.dinner'),vm.$i18n.t('menu.goodnight')],
                    vm.$toastr.success('Menu updated!', 'Menu successfully updated!');
                    vm.isLoading = false;
                    vm.$router.push({path: '/nutritionist/menus'});
                }).catch((error)=>{
                    vm.$toastr.error(this.$t('weeks.required_fields_error'), 'Error!');
                    vm.isLoading = false;
                });
            },

            /**
             * Calculate calories for created meals
            */
            calculateCalories: function(selected_type) {

                this.createdMeals.forEach((meal) => {

                    if(meal.type == selected_type) {

                        meal.foods.forEach((food) => {
                            this.meal_calories += food.energy_kc;
                        });
                    } else {
                        this.meal_calories = 0;
                    }
                });

                this.meal_calories = parseFloat(this.meal_calories).toFixed(2);

                switch(selected_type) {
                    case 'Breakfast':
                        this.breakfast_calories = this.meal_calories;
                        return this.breakfast_calories;
                    break;
                    case 'Brunch':
                        this.brunch_calories = this.meal_calories;
                        return this.brunch_calories;
                    break;
                    case 'Lunch':
                        this.lunch_calories = this.meal_calories;
                        return this.lunch_calories;
                    break;
                    case 'Afternoon':
                        this.afternoon_calories = this.meal_calories;
                        return this.afternoon_calories;
                    break;
                    case 'Dinner':
                        this.dinner_calories = this.meal_calories;
                        return this.dinner_calories;
                    break;
                    case 'Goodnight':
                        this.goodnight_calories = this.meal_calories;
                        return this.goodnight_calories;
                    break;
                    default:
                        this.breakfast_calories = this.meal_calories;
                        return this.breakfast_calories;
                    break;
                }
            },

            /**
             * Calculate calories for created meals
            */
            calcTotalCalForDay:function(day) {

                let total_per_day =  parseFloat(this.breakfast_calories) + parseFloat(this.brunch_calories) + parseFloat(this.lunch_calories) + parseFloat(this.afternoon_calories) + parseFloat(this.dinner_calories) + parseFloat(this.goodnight_calories);

                return parseFloat(total_per_day).toFixed(2);
            },

            updateMenus(){
                try {
                    DataMenuService.getMenus(this.getUser.nutritionist.id).then((menusRes)=>{
                        Models.CreatedMenu.create({ data: menusRes.data });
                    })
                } catch (err) {
                    console.log(err.message)
                }
            },

            addMeal(){
                this.createdMeals.push({
                    type: this.selectedType,
                    foods : this.selectedFoods,
                });

                let key = this.mealTypes.indexOf(this.selectedType);

                this.calculateCalories(this.selectedType);

                this.mealTypes.splice(key, 1);

                this.createdMealTypes.push(this.selectedType);
                this.selectedFoods = [];
                this.selectedType = this.mealTypes[0];
            },

            selectFoodType(){
                if(!!this.searchText && !!this.selectedFoodType){
                    var info = this.foodTypesData.find(el=>{
                        if(this.language == 'en'){
                            return el.info[0].name.indexOf(this.selectedFoodType) !== -1;
                        }else{
                            return el.info[1].name.indexOf(this.selectedFoodType) !== -1;
                        }
                    });

                    this.foodDataShow = this.foods.filter( elm => {
                        return elm.type.id == info.id;
                    });

                    this.foodDataShow = this.foodDataShow.filter(elm => {
                        if(this.language == 'en'){
                            return elm.english_title.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1;
                        }else{
                            return elm.hebrew_title.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1;
                        }
                    });
                }else if(!this.searchText && !!this.selectedFoodType){
                    var info = this.foodTypesData.find(el=>{
                        if(this.language == 'en'){
                            return el.info[0].name.indexOf(this.selectedFoodType) !== -1;
                        }else{
                            return el.info[1].name.indexOf(this.selectedFoodType) !== -1;
                        }
                    });

                    this.foodDataShow = this.foods.filter( (elm,index) => {
                        return elm.type.id == info.id;
                    });
                }else{
                    this.foodDataShow = this.foods.filter(elm => {
                        if(this.language == 'en'){
                            return elm.english_title.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1;
                        }else{
                            return elm.hebrew_title.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1;
                        }
                    });
                }
            },

            changeDayCalories: function() {

                this.breakfast_calories = 0;
                this.brunch_calories = 0;

                this.lunch_calories = 0;
                this.afternoon_calories = 0;

                this.dinner_calories = 0;
                this.goodnight_calories = 0;
            },

            /**
             * Get all weeks created by nutritionist
            */
            fetchWeeks: function() {
                WeekService.getAllWeeks(this.getUser.nutritionist.id)
                .then((response) => {
                    var all_weeks = response.data.weeks;

                    this.weeks.push(Object.assign({},{value: null, text: this.$t('weeks.select_week') }));

                    for(var i = 0; i < all_weeks.length; i++){
                        var option = [];
                        let interval = moment(all_weeks[i].start).format("DD/MM/YYYY")+' - '+moment(all_weeks[i].end).format("DD/MM/YYYY");

                        option["value"] = all_weeks[i].id;
                        option["text"] = all_weeks[i].title+' ('+interval+')';
                        option["start"] = all_weeks[i].start;
                        option["end"] = all_weeks[i].end;

                        this.weeks.push(Object.assign({},option));
                    }
                },err => {
                    this.weeks = [];
                });
            },
        },

        watch: {
            day: function() {
                //determine date of the week
                this.getDateOfWeek();
            },

            week: function() {
                this.getDateOfWeek();
            }
        }
    }
</script>
<style>
    .food-row{
        max-height: 400px;
        min-height: 100px;
        overflow-y: scroll;
        border: 1px solid;
    }

    .food-item{
        margin : 5px 0px;
    }

    .header{
        margin-top:30px;
    }

    .title-meals{
        margin-bottom: 10px;
        margin-top: 10px;
    }

    .main.create-menu{
        background-color:#ffffff;
    }

    .highlighted{
        background-color:#e4e5e6;
        padding:10px;
    }

    .not-highlighted{
        background-color:#ffffff;
        padding:10px;
    }

    .meals{
        /* margin:5px; */
        height:50px;
    }

    .type.not-highlighted{
        padding: 5px;
    }

    .fa-check{
        color: green;
        margin-left: 8px;
        font-size: 1.6em;
    }

    .data-value{
        color:red;
        text-align:center;
        font-weight: bold;
        font-size:14px;
    }

    .data-info{
        font-weight: bold;
        font-size:14px;
        text-align:center;
    }

    /* .food-modal{
        overflow-x:scroll;
    } */

    #basicRadios{
        justify-content: center;
        align-items: center;
    }

    .align-middle{
        align-items: center;
        display:flex;
    }

    .align-end{
        display:flex;
        justify-content: flex-end;
    }

    .remove-button{
        float: right;
        color: red;
        font-weight: 700;
    }

    .food-item.bordered{
        border:1px solid #c4c6c7;
        margin:0px;
    }

    .calc-calories {
        color: red;
        font-weight: bold;
    }
</style>